<formio-loader></formio-loader>
<div class="classification-indicators-wrapper">
    <!-- <h4>{{'forms.common.inicators' | translate}}</h4> -->
    <div class="row indicators">
        <div class="col-sm-4" *ngFor="let indicator of indicators" (click)="openIndicator(indicator)">
            <div class="card" [class.borderBottom]="indicator.hasComments">
                <div class="indicator-content">
                    <div>
                        <span class="icon">
                            <i class="{{indicator.icon || 'fa fa-handshake-o'}}"></i>
                        </span>
                        <div class="content">
                            {{indicator.name}}
                        </div>
                    </div>
                    <div class="completionRate">
                        <div><span [countUp]="indicator.completionRate"></span> %</div>
                        <span class="subTitle">{{'forms.common.completionRate' | translate}}</span>
                    </div>

                </div>

                <div class="indicator-actions">
                    <app-classification-indicator-status class="status" [status]="indicator.status">
                    </app-classification-indicator-status>

                    <span class="summary" *ngIf="!hideSummary"
                        (click)="$event.stopPropagation();openIndicator(indicator,true)">
                        {{'forms.common.indicatorShowSummary' | translate}}
                        <i class="fa fa-check-circle-o"></i>
                    </span>
                </div>
            </div>
        </div>
    </div>
</div>